import { z } from 'zod';
import { BooleanOptional, NumberOptional, StringOptional } from './schemaTypes';
import { LocationGroupType } from '@websky/graphql';
export const PassengerConfigSegmentSchema = z.object({
    arrival: z.union([z.literal('*'), z.string()]),
    departure: z.union([z.literal('*'), z.string()])
});
export const PassengerTypeConfigSchema = z.object({
    code: z.string(),
    parentCode: StringOptional,
    isAdult: BooleanOptional,
    noAvailableWith: z.array(z.string()).optional(),
    defaultCount: NumberOptional,
    onlyRoutes: z.array(z.array(PassengerConfigSegmentSchema)).optional(),
    disabledRoutes: z.array(z.array(PassengerConfigSegmentSchema)).optional(),
    disabled: BooleanOptional,
    maxCountWithoutAdult: NumberOptional,
    blockPayByMiles: BooleanOptional,
    maxCount: NumberOptional,
    isIndependent: BooleanOptional,
    requiredWithOneOf: z.array(z.string()).optional(),
    modifyCount: NumberOptional,
    group: StringOptional
});
const SelectableCurrencySchema = z.object({
    code: z.string(),
    symbol: StringOptional
});
const SearchFormLinkSchema = z.object({
    title: z.string(),
    url: z.string(),
    openInNewTab: BooleanOptional,
    icon: StringOptional,
    className: StringOptional
});
const LocationGroupTypesSchema = z.array(z.enum([
    LocationGroupType.AdditionalCities,
    LocationGroupType.Popular,
    LocationGroupType.Nearest,
    LocationGroupType.Country
]));
const LocationGroupsSchema = z.object({
    showAdditionalGroups: BooleanOptional,
    additionalGroupTypes: LocationGroupTypesSchema.optional()
});
const promoCodeWithAgreement = z.object({
    regex: z.instanceof(RegExp).or(z.string().transform(val => new RegExp(val))),
    code: z.string()
});
export const SearchFormSchema = z.object({
    redwingsForeignCardPaymentCheckbox: BooleanOptional,
    enableComplexRoute: BooleanOptional,
    maxComplexRouteSegments: NumberOptional,
    mobileFormType: z.enum(['common', 'alternative']).optional(),
    engineURL: StringOptional,
    payByMiles: BooleanOptional,
    showFfpBonusInfoInFares: BooleanOptional,
    requestCoordintates: z
        .object({
        desktop: BooleanOptional,
        mobile: BooleanOptional
    })
        .optional(),
    maxPassengersCount: NumberOptional,
    passengersConfig: z.array(PassengerTypeConfigSchema).optional(),
    offerHotels: BooleanOptional,
    offerHotelsDefaultState: BooleanOptional,
    offerHotelsLink: StringOptional,
    offerHotelsMainLink: StringOptional,
    offerHotelsSupplier: z.enum(['OSTROVOK', 'ONETWOTRIP']).optional(),
    offerHotelsAdditionalId: StringOptional,
    offerHotelsUtm: StringOptional,
    resultsURL: StringOptional,
    showPriceGraph: BooleanOptional,
    showPricesInDatepicker: BooleanOptional,
    proMode: BooleanOptional,
    selectableCurrencies: z.array(SelectableCurrencySchema).optional(),
    locationGroups: LocationGroupsSchema.optional(),
    startSearchButtonMode: z.enum(['text', 'image']).optional(),
    separatedDatepicker: BooleanOptional,
    promoCodesWithAgreement: z.array(promoCodeWithAgreement),
    additionalLinks: z.array(SearchFormLinkSchema).optional(),
    useFlightsSchedule: BooleanOptional,
    alwaysOpen: BooleanOptional
});
